const actionTypeIdentifier = 'E243837A-6B96-4185-B013-F81E3C2F3420';

export const getUserCostAllocation = `GET-USER-COST-ALLOCATION-${actionTypeIdentifier}`;
export const addUserCostAllocationDetails = `ADD-USER-COST-ALLOCATION-DETAILS-${actionTypeIdentifier}`;
export const updateUserCostAllocationItem = `UPDATE-USER-COST-ALLOCATION-ITEM-${actionTypeIdentifier}`;
export const deleteUserCostAllocationDetails = `DELETE-USER-COST-ALLOCATION-DETAILS-${actionTypeIdentifier}`;
export const getGLCodeList = `GET-GL-CODE-LIST-${actionTypeIdentifier}`;
export const getCostCodeList = `GET-COST-CODE-LIST-${actionTypeIdentifier}`;
export const setCostCodeLoading = `SET-COST-CODE-LOADING-${actionTypeIdentifier}`;
export const setGlCodeLoading = `SET-GL-CODE-LOADING-${actionTypeIdentifier}`;
export const getCostCodeDetailsList = `GET-COST-CODE-DETAILS-LIST${actionTypeIdentifier}`;
export const resetCostAllocation = `RESET-COST-ALLOCATION-${actionTypeIdentifier}`;


export const userCostAllocationFormModel = {
    Key: 0,
    CostAllocationID: -1,
    GLCodeID: null,
    GLCode: null,
    GLCodeName: null,
    CostCodeID: null,
    CostCode: null,
    CompanyCode: null,
    CostCodePercent: null,
    LastModified: null,
}

export const userCostAllocationTableFormModel = {
    Key: 0,
    CostAllocationID: -1,
    GLCodeID: null,
    GLCode: null,
    GLCodeName: null,
    CostCodeID: null,
    CostCode: null,
    CompanyCode: null,
    CostCodePercent: null,
    LastModified: null,
}